<template>
  <div id="replan">
    <el-row>
      <el-col :span="9" :offset="0.5">
        <el-row>
          <el-form :inline="true" @submit.native.prevent>
            <el-form-item>
              <span>请选择订单号:</span>
            </el-form-item>
            <el-form-item>
              <el-select v-model="orderId" placeholder="请选择">
                <el-option v-for="item in orders" :key="item.id" :label="item.id" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <span v-if="orders.length==0">未计划订单</span>
            </el-form-item>
          </el-form>
        </el-row>
        <el-row>
          <OrderLabel
            :order="order"
            :disabled="true"
            :label="label"
            :files="files"
            v-if="orderId"
            :users="users"
          ></OrderLabel>
        </el-row>
      </el-col>
      <el-col :span="9" :offset="2" v-if="orders.length!=0&&orderId!=''">
        <el-row>
          <h3>订单状态:</h3>
        </el-row>
        <el-row>
          <el-steps :active="order.status" finish-status="success">
            <el-step title="新订单"></el-step>
            <el-step title="刀模选取"></el-step>
            <el-step title="材料选取"></el-step>
            <el-step title="余量称重"></el-step>
            <el-step title="完成"></el-step>
          </el-steps>
        </el-row>
        <el-row>
          <el-date-picker
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="计划完成日期"
            v-model="planTime"
            style="width: 200px; margin:30px 20px 0 0;"
          ></el-date-picker>
          <el-button type="success" @click="commit">确定</el-button>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import OrderLabel from "@/components/production/OrderLabel";
export default {
  components: {
    OrderLabel
  },
  data: function() {
    return {
      orders: [],
      //终端发出
      postApi: {
        crud: "",
        info: {}
      },
      //终端接收
      message: {
        result: {
          infos: []
        }
      },
      orderId: "",

      //订单信息
      order: {},

      //标签信息
      label: {},

      //相关人员信息
      users: {},

      //附件信息
      files: {},

      planTime: ""
    };
  },
  created: function() {
    this.init();
  },
  watch: {
    orderId: async function(val) {
      if (val != "") {
        this.postApi.crud = "ri";
        this.postApi.info = {
          key: val
        };
        this.message = await this.$doPost(
          "/api/production/order",
          this.postApi
        );
        if (this.message.msgCode == 0) {
          this.order = this.message.result.infos.order;
          this.label = this.message.result.infos.label;
          this.files = this.message.result.infos.files;
          this.users = this.message.result.infos.users;
          this.planTime = this.order.planTime;
        } else {
          this.$message.error(this.message.msg);
        }
      }
    }
  },
  methods: {
    init: async function() {
      this.orderId = "";
      this.postApi.crud = "r";
      this.message = await this.$doPost("/api/plan/replan", this.postApi);
      if (this.message.msgCode == 0) {
        this.orders = this.message.result.infos;
      } else {
        this.$message.error(this.message.msg);
        this.orders = [];
      }
    },
    commit: async function() {
      console.log(this.planTime);
      var error = "";
      var ss = this.planTime == "";
      if (this.planTime == "") {
        error += "-请选择计划完成日期! ";
      }
      if (this.planTime == this.order.planTime){
        error += "-计划日期未改变! "
      }
    //   } else {
    //     var date = new Date(this.planTime.replace(/-/g, "/"));
    //     var date = new Date(this.planTime.replace(/-/g, "/"));        
    //     if (now.getTime() > date.getTime()) {
    //       error += "-计划日期不能大于下单日期 ";
    //     }
    //   }
      if (error == "") {
        this.postApi.crud = "u";
        this.postApi.info = {
          key: this.orderId,
          planTime: this.planTime
        };
        this.message = await this.$doPost("/api/plan/replan", this.postApi);
        if (this.message.msgCode == 0) {
          this.$message.success("提交成功");
          this.init();
        } else {
          this.$message.error(this.message.msg);
          this.planTime = '';
        }
      } else {
        this.$message.error(error);
      }
    }
  },
  props: {
    roles: Array
  }
};
</script>
<style>
/* td{
  margin-bottom: 
} */
</style>



// WEBPACK FOOTER //
// src/components/plan/RePlan.vue